export const url =
  process.env.REACT_APP_API_URL + "/" || "https://gameresource.vntt.com.vn/";